import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-empty-card',
  templateUrl: './empty-card.component.html',
  styleUrls: ['./empty-card.component.scss']
})
export class EmptyCardComponent {
  @Input() @HostBinding('style.--min-width') minWidth?: string;
  @Input() @HostBinding('style.--height') height?: string;

  @Input() text: string = '';

  constructor() {}
}
